import { render, staticRenderFns } from "./NewFolderDialog.vue?vue&type=template&id=4d448e68&"
import script from "./NewFolderDialog.vue?vue&type=script&lang=js&"
export * from "./NewFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports